export const extractCodesByProductKeyword = (keyword: string) => {
	const codes = keyword.split(',') ?? ['', ''];
	return {
		model: codes[0],
		code: codes[1],
	};
};
